import { useEffect, useState } from 'react';
import { ISearchResultVm } from '@yakoffice/publisher-types';
import { useRootStore } from './useRootStore';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useGetSearchResults {
    isLoaded: boolean;
    searchResults: ISearchResultVm[];
}

export const useGetSearchResult = (searchValue: string, searchAllGameEnvironments: boolean, searchLimit: number) => {

    const rootStore = useRootStore();
    const publishNotification = usePublishSnackbarNotification();
    const [result, setResult] = useState<useGetSearchResults>(() => ({ isLoaded: false, searchResults: [] }));

    useEffect(() => {
        setResult({ isLoaded: false, searchResults: [] });
        if (searchValue.length > 2) {
            rootStore.gameVersionStore.searchInGameVersion(rootStore.gameVersionStore.currentGameVersion ?? rootStore.gameVersionStore.gameVersions[0], searchValue, searchLimit)
                .then(results => {
                    if (!searchAllGameEnvironments)
                        setResult({
                            isLoaded: true,
                            searchResults: results.filter(result => {
                                return (result.gameEnvironmentId === null || result.gameEnvironmentId === rootStore.gameEnvironmentsStore.currentGameEnvironment?.id);
                            })
                        });
                    else
                        setResult({ isLoaded: true, searchResults: results });
                })
                .catch(e => {
                    publishNotification({
                        text: `Error loading Kind version: ${e.message}`,
                        canClose: true
                    });
                });
        }
    }, [searchAllGameEnvironments, rootStore.gameVersionStore, publishNotification, searchValue, searchLimit, rootStore.gameEnvironmentsStore.currentGameEnvironment?.id]);

    return result;
};
